<!-- @format -->

<info-bank-account-tag>

    <div class="container_contents">

        <div class="container_breadcrumb">
            <ul class="breadcrumb">
                <li class="breadcrumb-item"><a href="/info" class="information">会員情報</a></li>
                <li class="breadcrumb-item"><h1>銀行口座の登録・変更の申請</h1></li>
            </ul>

        </div><!--/.container_breadcrumb-->

        <div class="contents">
            <section class="contents_area">
                <div class="contents_block">

                    <h2 style="font-size: 2.5rem;text-align: center;margin-bottom:1rem">
                        銀行口座の登録・変更
                    </h2>

                    <p class="important_message important_message02 margin-spacing-2_bottom">
                        下記の銀行口座情報を入力いただき、「口座情報の登録・変更する」ボタンをクリックしてください。</p>

                    <h2 class="heading-03 margin-spacing-4_top margin-spacing-2_bottom">
                        銀行口座情報
                        <span class="status_label status_label-required margin-spacing-2_left"></span>
                    </h2>
                    <div is="bankform"></div>

                    <div class="margin-spacing-2_top">
                        <p class="note">
                            ※口座名義人と登録名が一致していないとお振り込みができません。屋号につきましては「屋号＋個人名」であればご登録可能です。</p>
                        <p class="note">※銀行口座の場合は普通口座のみの取り扱いとなります。</p>
                        <p class="note margin-spacing-2_bottom">
                            ※報酬額が残高の金額に関係なく、報酬額が確定した翌月に入金され繰り越しはされません。</p>
                    </div>
                </div>
            </section>
        </div>
    </div>


    <script>
        import bankform from "@tags/parts/info/bank-account/form.riot";
        import bankAccount from "@model/bankAccount/api";

        export default {
            components: {
                'bankform': bankform
            },
            bankAccount: bankAccount,
            listenerUpdate() {
                this.update()
            },
            onMounted(props, state) {
                this.bankAccount.on('update', this.listenerUpdate)
            },
            onUnmounted(props, state) {
                this.bankAccount.off('update', this.listenerUpdate)
            }
        }
    </script>
</info-bank-account-tag>
